import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import StoryCard from "@/components/StoryCard";
import StoryDetail from "@/components/StoryDetail";
import { Loader2 } from "lucide-react";

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [active, setActive] = useState(null);
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    api.get("/categories").then(({ data }) => {
      setCategories(data.categories || []);
      if ((data.categories || []).length) setActive(data.categories[0]);
    });
  }, []);

  useEffect(() => {
    if (!active) return;
    setLoading(true);
    api
      .get(`/stories?category=${encodeURIComponent(active)}&limit=40`)
      .then(({ data }) => setStories(data.stories || []))
      .finally(() => setLoading(false));
  }, [active]);

  return (
    <div data-testid="categories-page">
      <header className="border-b border-gray-200 px-8 py-6 sticky top-0 bg-white z-20">
        <div className="font-mono text-xs uppercase tracking-[0.25em] text-gray-500">
          Browse · 72 hours
        </div>
        <h1 className="font-serif text-4xl lg:text-5xl leading-none tracking-tight mt-2">
          Niches
        </h1>
        <div className="mt-5 flex flex-wrap gap-2">
          {categories.map((c) => (
            <button
              key={c}
              data-testid={`cat-tab-${c}`}
              onClick={() => setActive(c)}
              className={`px-3 py-1.5 text-xs font-mono uppercase tracking-widest border transition-colors ${
                active === c
                  ? "bg-[#0a0a0a] text-white border-[#0a0a0a]"
                  : "bg-white text-gray-700 border-gray-300 hover:border-[#0a0a0a]"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </header>

      <div className="px-2 lg:px-8 py-2">
        {loading ? (
          <div className="flex items-center gap-3 px-6 py-12 text-gray-500">
            <Loader2 size={18} className="animate-spin" />
            <span className="font-mono text-xs uppercase tracking-widest">Loading {active}…</span>
          </div>
        ) : stories.length === 0 ? (
          <div className="px-6 py-12 text-gray-500 font-mono text-xs uppercase tracking-widest">
            No fresh stories in this niche.
          </div>
        ) : (
          stories.map((s, i) => (
            <StoryCard key={s.id} story={s} index={i} onSelect={setSelected} />
          ))
        )}
      </div>

      {selected && (
        <StoryDetail story={selected} onClose={() => setSelected(null)} />
      )}
    </div>
  );
}
